import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, NgForm, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DocCategoryEX2Component } from '../../components/doc-category-ex2/doc-category-ex2.component';
import { DateRangePSComponent } from '../../components/date-range-ps/date-range-ps.component';
import { CompoundNameComponent } from '../../../shared/components/compound-name/compound-name.component';
import { CompoundAddressComponent } from '../../../shared/components/compound-address/compound-address.component';
import { CityTownEXComponent } from '../../../shared/components/city-town-ex/city-town-ex.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import * as NameActions from './../../../store/actions/compoundname.action';
//import * as RoleActions from './../../../store/actions/role.action';
import * as DateRangeActions from './../../../store/actions/daterange.action';
import * as CityActions from './../../../store/actions/citytown.action';
import * as DocTypeActions from './../../../store/actions/doctype.action';
import * as AddressActions from '../../../store/actions/address.action';
import * as DocCategories2Actions from '../../../store/actions/doccategories2.action';
import { DaterangeComponent } from '../../../shared/components/daterange/daterange.component';
import { DateRangeParentComponent } from '../../../shared/components/date-range-parent/date-range-parent.component';


@Component({
  selector: 'app-property-search-pg',
  templateUrl: './property-search-pg.component.html',
  styleUrls: ['./property-search-pg.component.css']
})
export class PropertySearchPgComponent implements OnInit {

  @ViewChild(DocCategoryEX2Component, { static: false }) docCategoryEX2Child;
  @ViewChild(CompoundNameComponent, { static: false }) compoundNameChild;
  //@ViewChild(CompoundAddressComponent) compoundAddressChild;
  @ViewChild(CityTownEXComponent, { static: false }) cityTownChild;
  //@ViewChild(DaterangeComponent) dateRangeChild;
  @ViewChild(DateRangeParentComponent, { static: false }) dateRangeChild;

  @ViewChild('f', { static: true }) propertySearchForm: NgForm;
  parentForm: UntypedFormGroup;

  constructor(private router: Router, private store: Store<AppState>, private fb: UntypedFormBuilder) { }

  ngOnInit() {

    //this.parentForm = this.fb.group({
    //});

    //this.propertySearchForm.form = this.fb.group({});

  }


  addRecToStore() {
    this.store.dispatch(new NameActions.AddName({
      fName: this.compoundNameChild.utilityobj.fName,
      lastcorpName: this.compoundNameChild.utilityobj.lastcorpName
    }));
    //this.store.dispatch(new AddressActions.AddAddress({
    //  streetNumber: this.compoundAddressChild.utilityobj.streetNumber,
    //  streetAddress: this.compoundAddressChild.utilityobj.streetAddress
    //}));
    this.store.dispatch(new CityActions.AddCity({
      citytowns: this.cityTownChild.utilityobj.citytowns
    }));
    this.store.dispatch(new DateRangeActions.AddDate({
      fromDate: this.dateRangeChild.utilityobj.fromDate, 
      toDate: this.dateRangeChild.utilityobj.toDate
    }));

    console.log(`docCategoryEX2Child.DocCategories2: ${JSON.stringify(this.docCategoryEX2Child.DocCategories2)}`);
    this.store.dispatch(new DocCategories2Actions.AddDocCategories2({
      //deeds: this.docCategoryEX2Child.DocCategories2.deeds,
      //homestead: this.docCategoryEX2Child.DocCategories2.homestead,
      //foreclosures: this.docCategoryEX2Child.DocCategories2.foreclosures,
      //liensAndMortgages: this.docCategoryEX2Child.DocCategories2.liensAndMortgages,
      //discharges: this.docCategoryEX2Child.DocCategories2.discharges,
      //allDocuments: this.docCategoryEX2Child.DocCategories2.allDocuments
      docCategory: this.docCategoryEX2Child.group.docCategory
    }));
  }
  /**
 * Delete input parameters from store.
 * @param index
 */
  delRecFromStore(index) {
    //this.store.dispatch(new RecActions.RemoveRec(index));
    this.store.dispatch(new NameActions.RemoveName(index));
    //this.store.dispatch(new AddressActions.RemoveAddress(index));
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new DocCategories2Actions.RemoveDocCategories2(index));

  }

  onSubmit(e) {
    if (this.propertySearchForm.valid) {

      this.delRecFromStore(0);

      this.addRecToStore();
      this.router.navigate(['/property-search-result-pg']);

    }
    else {
      this.validateAllFormFields(this.propertySearchForm.form);
    }
  }


  validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof UntypedFormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  ngAfterViewInit() {

    this.parentForm = this.fb.group({
    });

    this.propertySearchForm.form = this.fb.group({});

    this.propertySearchForm.form.addControl('compoundNameForm', this.compoundNameChild.form);
    this.compoundNameChild.form.setParent(this.propertySearchForm.form);
    //this.propertySearchForm.form.addControl('compoundAddressForm', this.compoundAddressChild.form);
    //this.compoundAddressChild.form.setParent(this.propertySearchForm.form);
    this.propertySearchForm.form.addControl('dateRangeForm', this.dateRangeChild.form);
    this.dateRangeChild.form.setParent(this.propertySearchForm.form);
    this.propertySearchForm.form.addControl('docCategories2Form', this.docCategoryEX2Child.form);
    this.docCategoryEX2Child.form.setParent(this.propertySearchForm.form);
    //this.propertySearchForm.form.addControl('dateRangeForm', this.dateRangeChild.form);
    //this.dateRangeChild.form.setParent(this.propertySearchForm.form);
  }

  search(url) { }
}
